<template>
  <div class="mt-6">
    <div class="grid grid-cols-4 gap-4 items-center">
      <div class="col-span-1">
        <label class="block text-right text-supplement font-semibold">{{$t('tour_departure_label')}}</label>
      </div>
      <div class="col-span-3">
        <departure-select />
      </div>
      <div class="col-span-1">
        <label class="block text-right text-supplement font-semibold">{{$t('tour_arrival_label')}}</label>
      </div>
      <div class="col-span-3">
        <arrival-select />
      </div>
      <div class="col-span-1">
        <label class="block text-right text-supplement font-semibold">{{$t('tour_seat_load_time')}}</label>
      </div>
      <div class="col-span-3">
        <date-input :serviceArea="serviceArea" />
      </div>
      <div class="col-span-1">
        <label class="block text-right text-supplement font-semibold">{{$t('tour_business_hours')}}</label>
        <p class="text-xs text-right">{{ operationHoursLabel }}</p>
      </div>
      <div class="col-span-3">
        <time-input :serviceArea="serviceArea" />
      </div>
      <div class="col-span-1">
        <label class="block text-right text-supplement font-semibold">{{$t('tour_persons_count')}}</label>
        <p class="text-xs text-right">{{$t('tour_total')}} {{ serviceArea.additional.capacity }}{{$t('tour_less')}}</p>
      </div>
      <div class="col-span-3">
        <capacity-input :max="serviceArea.additional.capacity" />
      </div>
    </div>
    <div class="text-right mt-4">
      <router-link :to="{ name: serviceArea.term }" class="text-link flex justify-end items-center" target="_blank">
        {{$t('tour_terms_of_service')}}
        <svg xmlns="http://www.w3.org/2000/svg" width="9.815" height="9.815" viewBox="0 0 9.815 9.815" class="ml-1">
          <path id="Rectangle" d="M6.634.5,6.94,6.488a.421.421,0,0,1-.451.451L.5,6.634a.539.539,0,0,1-.5-.5A.43.43,0,0,1,.123,5.8L5.8.123a.478.478,0,0,1,.673.034A.529.529,0,0,1,6.634.5Z" transform="translate(0 4.907) rotate(-45)" fill="#1998c8"/>
        </svg>
      </router-link>
    </div>
    <!--
    <div class="mt-4">
      <button @click="() => showModal('error')">エラー発生</button>
    </div>
    -->
    <div class="mt-4">
      <submit :serviceArea="serviceArea" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DepartureSelect from "../../molecules/TentativeDepartureSelect"
import ArrivalSelect from "../../molecules/TentativeArrivalSelect"
import DateInput from "../../molecules/TentativeDateInput"
import TimeInput from "../../molecules/TentativeTimeInput"
import CapacityInput from "../../molecules/TentativeCapacityInput"
import Submit from "../../molecules/TentativeSubmit"

export default {
  components: {
    DepartureSelect,
    ArrivalSelect,
    DateInput,
    TimeInput,
    CapacityInput,
    Submit
  },
  data () {
    return {
      places: []
    }
  },
  computed: {
    ...mapGetters({
      arrival: 'reservation/getArrival'
    }),
    serviceArea: function () {
      const id = this.$route.query.serviceAreaId
      const s = this.$store.getters['serviceAreas/get'](id)

      return s
    },
    operationHoursLabel: function () {
      const {
        operationStartTime,
        operationEndTime
      } = this.serviceArea.additional
      const start = operationStartTime && operationStartTime.substring(0, 5)
      const end = operationEndTime && operationEndTime.substring(0, 5)

      return `${start}-${end}`
    }
  }
}
</script>
